// extracted by mini-css-extract-plugin
export default {"list":"Breadcrumbs_list__Gs73j","listItem":"Breadcrumbs_listItem__1Yjyq","anchor":"Breadcrumbs_anchor__-7GJH"};